import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

const QuestionCircleIcon = () => {
  return <FontAwesomeIcon icon={faQuestionCircle} />;
};

export default QuestionCircleIcon;
